import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import "./style.scss";
import appConstants from "../../../appConstants";
import {
  NextStopCompliancesPopupMarker,
  NextStopCompliancePickupPopupMarker,
} from "../Markers";

const styles = (theme) => ({
  pickupMarker: {
    marginTop: 5,
    paddingLeft: 10,
    float: "left",
  },
  root: {
    width: "230px",
    height: "165px",
  },
  rootToolTip: {
    width: "230px",
    height: "85px",
  },
  table: {
    height: "100%",
    width: "100%",
  },
  tableHead: {
    backgroundColor: theme.headColor,
  },
  tableDeviation: {
    backgroundColor: theme.deviationStopColor,
  },
  tableHeadHeight: {
    height: "52px",
    "& $tableHeaderCell": {
      paddingTop: "6px",
    },
  },
  tableHeadCell: {
    color: theme.headFontColor,
    borderBottom: 0,
    fontSize: "12px",
  },
  customerName: {
    float: "left",
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "17px",
    width: "172px",
    textOverflow: "ellipsis",
    color: theme.address,
  },
  address: {
    clear: "both",
    fontSize: "10px",
    lineHeight: "20px",
    color: theme.address,
    paddingLeft: "12px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    height: "20px",
    width: "130px",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  tableRowRoot: {
    height: "25px",
  },
  dataCell: {
    borderBottom: 0,
    fontSize: 12,
    lineHeight: "17px",
    "&$firstTableCell": {
      paddingTop: "10px",
    },
    "&$lastTableCell": {
      paddingBottom: "15px",
    },
    "&$popupDataStyle": {
      paddingLeft: "12px",
    },
  },
  nameCellPadding: {
    paddingRight: "25px",
  },
  labelCell: {
    borderBottom: 0,
    fontSize: 10,
    paddingLeft: "12px",
    lineHeight: "14px",
  },
  firstTableCell: {
    paddingTop: "10px",
  },
  tableHeaderCell: {
    paddingTop: "6px",
  },
});
const ShowField = ({ classes, fieldName, fieldValue }) => {
  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell
        className={`${classes.nameCellPadding} ${classes.labelCell} tableCellName`}
      >
        {fieldName}
      </TableCell>
      <TableCell className={`${classes.dataCell} tableCellValue`}>
        {fieldValue}
      </TableCell>
    </TableRow>
  );
};
function NextStopComplianceStopPopup(props) {
  const { classes, theme, data, isOnHover } = props;
  const address = `${data.data.address}, ${data.data.city}`;
  return (
    <Paper
      className={`${
        isOnHover ? classes.rootToolTip : classes.root
      } popupBGColor`}
    >
      <Table className={classes.table} padding="none">
        <TableHead
          className={
            data.isDeviation ? classes.tableDeviation : classes.tableHead
          }
        >
          <TableRow className={classes.tableHeadHeight}>
            <TableCell colSpan={2} className={classes.tableHeaderCell}>
              <span className={classes.pickupMarker}>
                {data.data.stopType === appConstants.STOP_TYPE.Delivery ? (
                  <NextStopCompliancesPopupMarker data={data} />
                ) : (
                  <NextStopCompliancePickupPopupMarker data={data} />
                )}
              </span>
              <Tooltip
                classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
                title={data.data.displayCustomerName}
              >
                <div className={classes.customerName}>{data.data.displayCustomerName}</div>
              </Tooltip>
              <Tooltip
                classes={{ popper: "popper", tooltip: `tooltip-${theme}` }}
                title={address}
              >
                <div className={classes.address}>{address} </div>
              </Tooltip>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowField
            classes={classes}
            fieldName="Service Window"
            fieldValue={data.data.serviceWindow}
          ></ShowField>
          {!isOnHover && (
            <>
              <ShowField
                classes={classes}
                fieldName="Planned ETA"
                fieldValue={data.plannedArrivalTime}
              ></ShowField>
              <ShowField
                classes={classes}
                fieldName="Act Arr Time"
                fieldValue={data.actualArrivalTime}
              ></ShowField>
            </>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default withStyles(styles)(NextStopComplianceStopPopup);
